import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import scrollIntoView from 'scroll-into-view';
import { showLogin } from 'components/login/actions';
import { addCart, showCart } from 'components/cart/actions';
import Lightrail from './lightrail';
import Product from 'components/brands/Product';
import { WideContainer } from 'scy/layouts';
import { Hero, H3, Paragraph, AccentBody, H6, Subtitle } from 'scy/text';
import border from 'scy/border.mod.scss';
import { PrimaryButton, BUTTON_CLASSES } from 'scy/buttons';
import GiftIcon from 'images/icons/gift.svg?react-svg';
import BottleIcon from 'images/icons/bottle-hand.svg?react-svg';
import CocktailIcon from 'images/icons/cocktail-hand.svg?react-svg';
import ArrowRight from 'images/icons/controls/chevron-right.svg?react-svg';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import { tablet_flex } from 'scy/display.mod.scss';
import {
  flex,
  centerItems,
  spaceBetween,
  spaceAround
} from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

class Gifting extends React.Component {
  add(product) {
    this.props.addCart(product, 1);
    setTimeout(this.props.showCart, 500);
  }

  scrollToBrowse() {
    const browseSection = this.browseSection;
    if (browseSection) scrollIntoView(browseSection, { align: { top: 0.2 } });
  }

  render() {
    return (
      <div className={`${pageContainer} ${borderBox}`}>
        <Hero
          className={`${textCenter} ${padding.tablet_top_md}`}
          marginClass={`${margin.top_lg} ${margin.bottom_lg}`}
        >
          Send a Gift
        </Hero>

        <WideContainer>
          <div className={`${tablet_flex} ${spaceBetween}`}>
            <section className={styles.ctaSection}>
              <AccentBody className={styles.ctaIcon}>
                <GiftIcon />
              </AccentBody>
              <H3 className={styles.ctaTitle}>Send a Gift Card</H3>
              <Paragraph className={styles.ctaCaption}>
                Can’t figure out which bottle would be perfect? Send them a
                Saucey Gift Card and let them choose their own gift. They will
                be toasting to you soon!
              </Paragraph>
              <Lightrail
                shopperToken={this.props.shopperToken}
                login={() => this.props.showLogin('signup')}
              />
            </section>

            <section className={styles.ctaSection}>
              <AccentBody className={styles.ctaIcon}>
                <BottleIcon />
              </AccentBody>
              <H3 className={styles.ctaTitle}>Send a Bottle</H3>
              <Paragraph className={styles.ctaCaption}>
                Saucey can deliver your recipient’s favorite bottle right to
                their door in as little as 30 minutes. Shop curated gift
                packages or send their favorite bottle.
              </Paragraph>
              <PrimaryButton
                type="button"
                className={styles.ctaButton}
                onClick={() => this.scrollToBrowse()}
              >
                Browse Gifts
              </PrimaryButton>
            </section>

            <section className={styles.ctaSection}>
              <AccentBody className={styles.ctaIcon}>
                <CocktailIcon />
              </AccentBody>
              <H3 className={styles.ctaTitle}>
                Special Requests & Corporate Gifts
              </H3>
              <Paragraph className={styles.ctaCaption}>
                Have lots of gifts to give or need something very special?
                Contact us and we’ll help you get everything taken care of at{' '}
                <a href="mailto:gifting@saucey.com">gifting@saucey.com</a>.
              </Paragraph>
              <a
                href="mailto:gifting@saucey.com"
                className={`${BUTTON_CLASSES.primary} ${styles.ctaButton}`}
              >
                Contact Us
              </a>
            </section>
          </div>

          <div
            ref={div => (this.browseSection = div)}
            className={`${margin.md} ${margin.desktop_left_lg} ${
              margin.desktop_right_lg
            } ${border.bottomMedium}`}
          >
            <H6
              uppercase
              marginClass={`${margin.top_0} ${margin.bottom_md}`}
              className={styles.browseGiftsHeading}
            >
              <span>Browse Gifts</span>
            </H6>
            <div className={`${tablet_flex} ${centerItems} ${spaceAround}`}>
              <CategoryLink
                to="/best-gifts?order=desc&sort=price"
                title="Best-sellers"
              />
              <CategoryLink to="/wine" title="Wine Lovers" />
              <CategoryLink to="/safe-bets" title="Safe Bets" />
              <CategoryLink
                to="/great-for-breakups"
                title="Great for Breakups"
              />
            </div>
          </div>

          <div
            className={`${margin.md} ${margin.desktop_left_lg} ${
              margin.desktop_right_lg
            } ${padding.top_sm} ${textCenter}`}
          >
            <div className="row">
              {this.props.products.map(product => (
                <div key={product.sku_id} className="col-xs-6 col-sm-3">
                  <Product product={product} add={() => this.add(product)} />
                </div>
              ))}
            </div>
          </div>
        </WideContainer>
      </div>
    );
  }
}

function CategoryLink({ to, title }) {
  return (
    <Link
      to={to}
      className={`${flex} ${centerItems} ${spaceBetween} ${margin.bottom_md}`}
    >
      <Subtitle tag="div">{title}</Subtitle>
      <span className={styles.browseGiftsArrow}>
        <ArrowRight />
      </span>
    </Link>
  );
}

const ConnectedGifting = connect(
  state => ({
    shopperToken: state.gifting.shopperToken,
    products: state.gifting.products
  }),
  { showLogin, addCart, showCart }
)(Gifting);

export default ConnectedGifting;
